/// <amd-module name="Repos/Views/CommitHub/Discussion/CommitDiscussionThreadService" />
import { IArtifactDiscussionThreadModel } from "Repos/Artifact/Discussion/ArtifactDiscussionContracts";
import { ArtifactDiscussionThreadService, IArtifactDiscussionThreadService } from "Repos/Artifact/Discussion/ArtifactDiscussionThreadService";
import { DiscussionThread } from "Repos/Artifact/Discussion/Contracts/Discussion";
import { getArtifactUri } from "Repos/Common/Util/Commit";
import { IVCViewModelDataProviderService } from "Repos/Common/VCViewModelDataProviderService";
import { DiscussionThreadPermissions } from "Repos/Discussion/DiscussionThread.Types";
import { IObservableValue, IReadonlyObservableValue, ObservableValue } from "VSS/Core/Observable";
import { IVssPageContext, Services } from "VSS/Platform/Context";
import { getCommitData } from "../CommitData";
import { CommitPermissions, hasPermission } from "../CommitPermissionService";

export interface ICommitDiscussionThreadService extends IArtifactDiscussionThreadService {
    getFirstThreadAdded(): IReadonlyObservableValue<boolean>;
    setFirstThreadAdded(value: boolean): void;
}

class CommitDiscussionThreadService extends ArtifactDiscussionThreadService implements ICommitDiscussionThreadService {
    private threadEverAdded = false;
    private firstThreadAdded = new ObservableValue(false);

    public addThread(thread: IArtifactDiscussionThreadModel): void {
        if (!this.threadEverAdded) {
            this.firstThreadAdded.value = true;
            this.threadEverAdded = true;
        }

        super.addThread(thread);
    }

    public getFirstThreadAdded(): IObservableValue<boolean> {
        return this.firstThreadAdded;
    }

    public setFirstThreadAdded(value: boolean): void {
        this.firstThreadAdded.value = value;
    }

    protected processThreads(threads: DiscussionThread[]): void {
        this.threadEverAdded = threads.length > 0;
        super.processThreads(threads);
    }

    protected getArtifactUri(): string {
        const { pageContext } = this;
        const vcViewModelDataProviderService = pageContext.getService<IVCViewModelDataProviderService>("IVCViewModelDataProviderService");
        const repository = vcViewModelDataProviderService.getRepository()!;
        const commitId = getCommitData(pageContext)!.commitDetails.commitId as string;

        return getArtifactUri(repository.project.id, repository.id, commitId);
    }

    protected getPermissions(pageContext: IVssPageContext): DiscussionThreadPermissions {
        let permissions: DiscussionThreadPermissions = DiscussionThreadPermissions.None;
        if (hasPermission(pageContext, CommitPermissions.AddEditComment)) {
            permissions = permissions | DiscussionThreadPermissions.ManageComment;
        }

        if (hasPermission(pageContext, CommitPermissions.UpdateCommentStatus)) {
            permissions = permissions | DiscussionThreadPermissions.ChangeStatus;
        }

        return permissions;
    }
}

const serviceName = "ICommitDiscussionThreadService";
Services.add(serviceName, { serviceFactory: CommitDiscussionThreadService });

export function getCommitDiscussionService(pageContext: IVssPageContext): ICommitDiscussionThreadService {
    return pageContext.getService<ICommitDiscussionThreadService>(serviceName);
}
